import React, { useState, memo } from "react";
import { Button } from "@mui/material";
import ExcelJS from "exceljs";
import moment from "moment-jalaali";
import Api from "../../../utils/api";
import { Loading } from "../../../components";

const RewardSaderatExcel = ({ object, period_id }) => {
    const [loading, setLoading] = useState(false);

    const makeShaba = (number) => {
        let output = [];
        for (let i = 0; i < 7; i++) {
            output.push(number.slice(0, 4));
            number = number.slice(4);
        }
        return output.join("-");
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await new Api().get(`/period/${period_id}/export`, object);
            const items = response?.data || [];

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Saderat");

            worksheet.columns = [
                { header: "fromAccount", key: "fromAccount", width: 20 },
                { header: "toAccount", key: "toAccount", width: 40 },
                { header: "firstName", key: "firstName", width: 20 },
                { header: "lastName", key: "lastName", width: 20 },
                { header: "corporationName", key: "corporationName", width: 20 },
                { header: "amount", key: "amount", width: 20 },
                { header: "description", key: "description", width: 40 },
            ];

            items.forEach((item) => {
                worksheet.addRow({
                    fromAccount: item.account_number || "-",
                    toAccount:
                        item.shaba && item.shaba !== "-"
                            ? makeShaba("IR" + item.shaba)
                            : "",
                    firstName: item.first_name || "",
                    lastName: item.last_name || "",
                    corporationName: "",
                    amount: item.total_pay * 10 || 0,
                    description: `پورسانت دوره ${period_id}`,
                });
            });

            worksheet.getRow(1).eachCell((cell) => {
                cell.font = { bold: true, size: 15 };
                cell.alignment = { horizontal: "center", vertical: "center" };
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "FFCCEEFF" },
                };
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" },
                };
            });

            worksheet.eachRow({ includeEmpty: false }, (row, index) => {
                if (index > 1) {
                    row.eachCell((cell) => {
                        cell.font = { size: 13 };
                        cell.alignment = { horizontal: "center", vertical: "center" };
                    });
                }
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `saderat_${period_id}_${moment().unix()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error("خطا در صادرات بانک صادرات:", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Button
                size="small"
                variant="outlined"
                color="default"
                onClick={fetchData}
                disabled={loading}
            >
                خروجی بانک صادرات
            </Button>
            {loading && <Loading />}
        </>
    );
};

export default memo(RewardSaderatExcel);
